import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import {
  IAllOrganizationsResponse,
  IOrganizationAdminInviteRequest,
  IOrganizationAdminsResponse,
  IOrganizationRequest,
  IOrganizationResponse,
} from '@/types/organizations';

class OrganizationsApi extends AbortControllerManager {
  private ORGANIZATIONS_URL = '/v2/organizations';

  constructor() {
    super();
  }

  getOrganizations(): Promise<IAllOrganizationsResponse> {
    const signal = this.createAbortController('getOrganizations');
    return authClient.get(this.ORGANIZATIONS_URL, { signal });
  }

  createOrganization(
    payload: IOrganizationRequest,
  ): Promise<IOrganizationResponse> {
    const signal = this.createAbortController('createOrganization');
    return authClient.post(this.ORGANIZATIONS_URL, payload, { signal });
  }

  updateOrganization(
    id: string,
    payload: IOrganizationRequest,
  ): Promise<IOrganizationResponse> {
    const signal = this.createAbortController(`updateOrganization-${id}`);
    return authClient.put(`${this.ORGANIZATIONS_URL}/${id}`, payload, {
      signal,
    });
  }

  getOrganizationAdmins(id: string): Promise<IOrganizationAdminsResponse> {
    const signal = this.createAbortController(`getOrganizationAdmins-${id}`);
    return authClient.get(`${this.ORGANIZATIONS_URL}/${id}/admins`, { signal });
  }

  inviteOrganizationAdmin(
    id: string,
    payload: IOrganizationAdminInviteRequest,
  ): Promise<void> {
    const signal = this.createAbortController(`inviteOrganizationAdmin-${id}`);
    return authClient.post(
      `${this.ORGANIZATIONS_URL}/${id}/admins/invite`,
      payload,
      { signal },
    );
  }

  removeOrganizationAdmin(id: string, userId: string): Promise<void> {
    const signal = this.createAbortController(
      `removeOrganizationAdmin-${id}-${userId}`,
    );
    return authClient.delete(
      `${this.ORGANIZATIONS_URL}/${id}/admins/${userId}`,
      {
        signal,
      },
    );
  }
}

export const organizationsApi = new OrganizationsApi();
